import { type ReactNode } from 'react'
import { cn } from '@quickmd-llc/design-system'
import './EditCardAccountInfo.scss'

type Props = {
  title: string
  children: ReactNode
  className?: string
}

export function EditCardAccountInfo({ title, children, className }: Props) {
  return (
    <div className={cn('edit-card-account-info-main-wrapper', className)}>
      <div className='edit-card-account-info-title'>{title}</div>

      {children}
    </div>
  )
}
